<!--
 * @Description: 筛选组件
 * @FilePath: packages/vue-m-comprehensive/src/components/FilterSelect/index.vue
-->
<template>
  <div class="content">
    <div class="filter-option">
      <div
        v-for="(item, index) in options"
        :key="index"
        class="filter-item"
        @click="onOption(item)"
      >
        <span
          v-if="item.filterType !== 'filter'"
          :class="{ focus: item.isFocus }"
          >{{ item.name === '全部' ? '科室' : item.name }}</span
        >
        <span v-else :class="{ focus: item.isFocus || isHeightFilter }">{{
          item.name
        }}</span>
        <img
          v-if="item.filterType !== 'filter'"
          :src="
            item.isFocus
              ? 'https://staff.chunyu.mobi/@/media/images/2022/01/09/6303/13aee4664943_w18_h9_.png'
              : 'https://staff.chunyu.mobi/@/media/images/2022/01/09/e7b4/ba44507acb5c_w18_h9_.png'
          "
          alt="三角形上"
        />
        <img
          v-else
          class="filter-icon"
          :src="
            !item.isFocus && !isHeightFilter
              ? 'https://staff.chunyu.mobi/@/media/images/2021/12/31/50f9/45bfc12e64f3_w39_h39_.png'
              : 'https://staff.chunyu.mobi/@/media/images/2021/12/31/9b80/34b99b9678f2_w39_h39_.png'
          "
          alt="筛选"
        />
      </div>
    </div>
    <div v-if="showSelBar" class="sel-bar">
      <div v-if="currentOption.filterType === 'select'" class="location">
        <div class="first">
          <div
            v-for="(item, index) in currentOption.data"
            :key="index"
            :class="{
              'option-item': true,
              focus: item.value === optionValue[currentOption.index][0],
            }"
            @click="
              onChange(
                item,
                currentOption.index,
                'first',
                currentOption.index === 0 ? '地区筛选' : '科室筛选'
              )
            "
          >
            {{ item.text }}
          </div>
        </div>
        <div class="second">
          <div
            v-for="(item, index) in secondData"
            :key="index"
            :class="{
              'option-item': true,
              focus: optionValue[currentOption.index][1] === item.value,
            }"
            @click="
              onChange(
                item,
                currentOption.index,
                'second',
                currentOption.index === 0 ? '地区筛选' : '科室筛选'
              )
            "
          >
            {{ item.text }}
          </div>
        </div>
      </div>
      <div v-if="currentOption.filterType === 'filter'" class="filter-content">
        <div
          v-for="(item, index) in currentOption.data"
          :key="index"
          class="filter-option-content"
        >
          <div class="title">
            {{ item.title }}
          </div>
          <div class="btn-content">
            <div
              v-for="(e, i) in item.options || []"
              :key="i"
              :class="{
                tag: true,
                focus:
                  filterValue[item.key].findIndex(ele => ele === e.value) !==
                  -1,
              }"
              @click="
                onTag(
                  item,
                  e,
                  filterValue[item.key].findIndex(ele => ele === e.value) !== -1
                )
              "
            >
              {{ e.name }}
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="canel" @click="onCancel">
            重置
          </div>
          <div class="confirm" @click="onConfirm">
            确定
          </div>
        </div>
      </div>
      <div v-if="currentOption.filterType === 'sort'" class="sort-content">
        <div
          v-for="(ele, index) in currentOption.data"
          :key="index"
          :class="{
            'sort-item': true,
            focus: optionValue[currentOption.index][0] === ele.value,
          }"
          @click="onSortItem(ele)"
        >
          {{ ele.name }}
        </div>
      </div>
      <div v-if="currentOption.filterType === 'multistage'">
        <MultisSelect :data="currentOption.data" @onChange="onMulChange" />
      </div>
      <div class="outer-mask">
        <div class="mask" @click="onClose" />
      </div>
    </div>
  </div>
</template>
<script>
import MultisSelect from './MultisSelect.vue';

export default {
  name: 'FilterSelect',
  components: { MultisSelect },
  props: {
    // 筛选配置
    filterOptions: {
      type: Array,
      default: () => [],
    },
    // 传入的值 注意数据结构必须和下方相同，onChange也会传出相同数据结构的值
    value: {
      type: Array,
      default: () => [
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
      ],
    },
    // 是否高亮筛选
    isHeightFilter: {
      type: Boolean,
      default: () => false,
    },
    mountElement: {
      type: String,
      default: () => '',
    },
  },
  data: () => {
    return {
      options: [], // 接收选项
      showSelBar: false, // 是否展示下拉框
      currentOption: {}, // 当前被选择的类别
      currentFirst: {}, // 当前被选择的第一选项
      optionValue: [
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
      ], // 当前筛选项的值
      filterValue: {
        hospital_grade: [],
        hospital_nature: [],
        hospital_type: [],
        '0': [],
        '1': [],
        '2': [],
        '3': [],
      },
    };
  },
  computed: {
    // 选择二级
    secondData() {
      return this.currentFirst.childer || {};
    },
  },
  watch: {
    showSelBar() {
      this.$emit('optionItemChange', !this.showSelBar);
      const mountElement = document.getElementById(this.mountElement);
      if (!mountElement) {
        return;
      }
      if (this.showSelBar) {
        document.body.style.overflow = 'hidden';
        mountElement.setAttribute('style', 'overflow: hidden');
      } else {
        document.body.style.overflow = 'visible';
        mountElement.setAttribute('style', 'overflow: auto');
      }
    },
    // 监听value的变化
    value(val) {
      this.optionValue = this.value;
      const arr = this.optionValue;
      this.options.map((item, index) => {
        if (item.filterType === 'select') {
          item.data.map(ele => {
            if (ele.value !== arr[index][0]) return;
            if (ele.childer.find(e => e.value === arr[index][1])) {
              this.options[index].name = ele.childer.find(
                e => e.value === arr[index][1]
              ).text;
            }
            return ele;
          });
        }
        return item;
      });
      if (this.options.length === 3) {
        this.filterValue.hospital_grade = arr[2].hospital_grade;
        this.filterValue.hospital_nature = arr[2].hospital_nature;
        this.filterValue.hospital_type = arr[2].hospital_type;
      } else {
        this.options[3].name =
          arr[3][0] === '' ? this.options[3].name : '按价格';
        this.filterValue['0'] = arr[4][0].split(',') || [];
        this.filterValue['1'] = arr[4][1].split(',') || [];
      }
      if (val[0][0] && val[0][1]) {
        // eslint-disable-next-line prefer-destructuring
        this.options[0].name = val[0][1];
      }
    },
  },
  created() {
    this.options = this.filterOptions;
    this.optionValue = this.value;
  },
  methods: {
    /**
     * 点击头部的筛选项，切换筛选的类别
     *
     * @param {object} option 当前被切换到的位置
     */
    onOption(option) {
      this.currentOption = {};
      this.options = this.options.map((item, index) => {
        if (item.name === option.name) {
          item.isFocus = !item.isFocus;
        } else {
          item.isFocus = false;
        }
        if (item.isFocus) {
          this.currentOption = item;
          this.currentOption.index = index;
          const value = this.optionValue[index].length
            ? this.optionValue[index][0]
            : '';
          this.currentFirst = this.currentOption.data.length
            ? this.currentOption.data.find(ele => ele.value === value) || {}
            : {};
        }
        return item;
      });
      this.showSelBar = this.options.some(item => item.isFocus);
    },
    /**
     * 选择发生改变的回调函数
     *
     * @param {object} item 被选择的值
     * @param {number} index 选择的第几个类别
     * @param {string} sel 第一级选择or第二级选择
     * @param {string} filterCategory 筛选的类别
     */
    onChange(item, index, sel, filterCategory) {
      if (sel === 'first') {
        this.currentFirst = item;
        this.optionValue[index] = [item.value, ''];
      } else {
        this.optionValue = this.optionValue.map((e, i) => {
          if (i === index) {
            return [e[0], item.value];
          }
          return e;
        });
        this.options[index].name = item.text;
        this.showSelBar = false;
        this.onOption(this.options[index].name);
        this.$emit('change', this.optionValue, filterCategory);
      }
    },
    /**
     * 筛选项按钮点击事件
     *
     * @param {object} item 当前被点击的组
     * @param {object} e 当前被点击的元素
     * @param {object} isDelete 取消or选择
     */
    onTag(item, e, isDelete) {
      if (isDelete) {
        this.filterValue[item.key] = this.filterValue[item.key].filter(
          ele => ele !== e.value
        );
      } else {
        this.filterValue[item.key].push(e.value);
      }
    },
    // 确认事件
    onConfirm() {
      const arr = [...this.optionValue];
      if (this.options.length > 3) {
        arr[this.currentOption.index] = [
          this.filterValue['0'].join(','),
          this.filterValue['1'].join(','),
        ];
      } else {
        arr[this.currentOption.index] = this.filterValue;
      }
      this.optionValue = arr;
      this.onOption(this.options[this.currentOption.index].name);
      this.$emit('change', this.optionValue, '普通筛选');
      this.showSelBar = false;
    },
    // 重置事件
    onCancel() {
      this.filterValue = {
        hospital_grade: [],
        hospital_nature: [],
        hospital_type: [],
        '0': [],
        '1': [],
      };
    },
    /**
     * 排序点击事件
     *
     * @param {object} item 当前被选择的排序方式
     */
    onSortItem(item) {
      const arr = [...this.optionValue];
      arr[this.currentOption.index][0] = item.value;
      this.optionValue = arr;
      let name;
      if (item.value.indexOf('price') > -1) {
        name = '按价格';
      } else if (item.value.indexOf('discount') > -1) {
        name = '折扣力度';
      } else {
        name = item.name;
      }
      this.options[this.currentOption.index].name = name;
      this.$emit('change', this.optionValue, '排序');
      this.showSelBar = false;
      this.onOption(this.options[this.currentOption.index].name);
    },
    /**
     * 多级选择事件
     *
     * @param {string} disName 当前疾病名字
     */
    onMulChange(disName) {
      this.$emit('onMulChange', disName);
      this.onOption('疾病');
      this.showSelBar = false;
    },
    /**
     * 点击蒙层，关闭筛选
     */
    onClose() {
      const arr = this.value[4];
      if (this.options.length > 3) {
        this.filterValue['0'] = arr[0].split(',');
        this.filterValue['1'] = arr[1].split(',');
      }
      this.onOption(this.options[this.currentOption.index].name);
      this.$emit('onClose');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.content {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: rem(12) 0;
  background: #fff;
}
.filter-option {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100%;
}
.filter-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: rem(85);
  height: 100%;
  color: #666;
  font-size: rem(15);
  img {
    width: rem(6);
  }
  img.filter-icon {
    width: rem(13);
    height: rem(13);
  }
  span {
    margin-top: rem(2);
    margin-right: rem(4);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  span.focus {
    color: #39d167;
  }
}
.sel-bar {
  position: absolute;
  top: rem(40);
  right: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  min-height: rem(120);
  // max-height: rem(240);
  background: #fff;
  .location {
    display: flex;
    width: 100%;
    .first {
      width: 50%;
      max-height: rem(360);
      overflow: auto;
      background: #f4f4f4;
    }
    .second {
      width: 50%;
      max-height: rem(360);
      overflow: auto;
    }
  }
}
.second {
  padding-left: rem(18);
  .option-item {
    text-align: left;
  }
  .focus {
    color: #39d167;
  }
}
.option-item {
  width: 100%;
  height: rem(40);
  overflow: hidden;
  color: #666;
  font-size: rem(15);
  line-height: rem(40);
  white-space: nowrap;
  text-overflow: ellipsis;
  border-bottom: rem(0.5) solid #f7f7f7;
}
.first {
  .option-item {
    padding: rem(0) rem(18);
    text-align: left;
  }
}
.option-item.focus {
  color: #39d167;
  background: #fff;
}
.tag {
  width: rem(108);
  height: rem(30);
  margin-right: rem(10);
  margin-bottom: rem(10);
  color: #666;
  font-size: rem(12);
  line-height: rem(30);
  background: #f7f7f7;
  border: rem(1) solid #f7f7f7;
  border-radius: rem(4);
}
.tag.focus {
  color: #39d167;
  line-height: rem(30);
  background: rgba(57, 209, 103, 0.06);
  border: rem(1) solid #39d167;
  border-radius: rem(4);
}
.filter-content {
  padding: rem(20) rem(5) rem(20) rem(15);
  text-align: center;
  .title {
    margin-bottom: rem(15);
    color: #323232;
    font-weight: 500;
    font-size: rem(15);
    text-align: left;
  }
  .btn-content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: rem(10);
  }
}
.footer {
  display: flex;
  div {
    width: rem(165);
    height: rem(44);
    font-size: rem(16);
    line-height: rem(44);
    border: rem(0.5) solid #e7e7e7;
    border-radius: rem(22);
  }
  .canel {
    margin-right: rem(10);
    color: #323232;
  }
  .confirm {
    color: #fff;
    background: #39d167;
  }
}
.sort-content {
  .sort-item {
    display: flex;
    align-items: center;
    height: rem(40);
    padding: 0 rem(18);
    color: #666;
    font-size: rem(15);
    letter-spacing: 0;
    border-top: rem(0.5) solid #f4f4f4;
  }
  .sort-item.focus {
    color: #39d167;
  }
}
.outer-mask {
  position: relative;
}
.mask {
  position: absolute;
  // left: 0;
  top: 0;
  // right: 0;
  // bottom: 0;
  width: 100%;
  height: 2000px;
  background: #000;
  opacity: 0.6;
}
</style>
